(() => {
  const initMaterialGuide = (scope = document) => {
    const guides = scope.querySelectorAll?.('.mg-page') || [];

    guides.forEach((guide) => {
      const dialog = guide.querySelector('[data-mg-lightbox]');
      if (!dialog || dialog.dataset.bound === 'true') return;

      const image = dialog.querySelector('[data-mg-lightbox-image]');
      const caption = dialog.querySelector('[data-mg-lightbox-caption]');
      const closeButton = dialog.querySelector('[data-mg-lightbox-close]');
      let returnFocus = null;

      const closeDialog = () => {
        if (dialog.open && typeof dialog.close === 'function') {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
          document.documentElement.classList.remove('mg-lightbox-is-open');
          returnFocus?.focus();
        }
      };

      guide.querySelectorAll('[data-mg-lightbox-open]').forEach((trigger) => {
        trigger.addEventListener('click', () => {
          returnFocus = trigger;
          image.src = trigger.dataset.image || '';
          image.alt = trigger.dataset.alt || '';
          caption.textContent = trigger.dataset.caption || '';
          document.documentElement.classList.add('mg-lightbox-is-open');

          if (typeof dialog.showModal === 'function') {
            dialog.showModal();
          } else {
            dialog.setAttribute('open', '');
          }

          closeButton?.focus();
        });
      });

      closeButton?.addEventListener('click', closeDialog);

      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) closeDialog();
      });

      dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('mg-lightbox-is-open');
        image.removeAttribute('src');
        returnFocus?.focus();
      });

      dialog.dataset.bound = 'true';
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initMaterialGuide());
  } else {
    initMaterialGuide();
  }

  document.addEventListener('shopify:section:load', (event) => initMaterialGuide(event.target));
})();
